module.exports = __webpack_public_path__ + "6a803acb4c81860bad1b0d7d06271ae1.svg";